import {Component, Input, OnInit} from '@angular/core';
import {EscolaService} from '../../services/escola.service';
import {Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-listagem-etapas-cursos',
  templateUrl: './listagem-etapas-cursos.component.html',
  styleUrls: ['../userpanel.component.css', 'listagem-etapas-cursos.component.css'],
  providers: [EscolaService]
})

export class ListagemEtapasCursosComponent implements OnInit {

  @Input()
  private idTrail: number;

  // Dados
  private dataList: any[];

  public loaderActivated: boolean;

  constructor(private _escolaService: EscolaService, private _router: Router) {
    this.loaderActivated = true;
  }

  ngOnInit() {
    this.getStepListByIdTrail(this.idTrail);
  }

  public getStepListByIdTrail(idTrail: number): void {
    this._escolaService.getStepByTrail(idTrail)
      .subscribe(
        res => {
          this.dataList = this.checkModuleCounter(res.data);
        }
      );
  }

  public addCounterToDataList(data: any[]): any[] {
    let counter = 1;
    for (const item of data) {
      item.counter = counter;
      counter++;
    }
    return data;
  }

  public checkModuleCounter(data: any[]): any[] {
    if (data.length == 1) {
      this._router.navigate(['/visualizador/etapa', data[0].id]);
    } else {
      this.loaderActivated = false;
      return this.addCounterToDataList(data);
    }
  }

  public redirectToAva(data: any, direct: boolean = false): any {
    if (data.porcentagem < 100 && direct === false) {
      this.registerStepProgress(data.id)
        .subscribe(
          res => {
            this._router.navigate(['/visualizador/etapa/', data.id]);
          }
        );
    } else {
      this._router.navigate(['/visualizador/etapa/', data.id]);
    }
  }

  public registerStepProgress(id: number): Observable<any> {
    return this._escolaService.registerNewProgress(id, this.idTrail);
  }

  public continueByLastStep(): void {
    this._escolaService.getProgressByTrailId(this.idTrail)
      .subscribe(
        res => {
          if (res.data.length <= 0) {
            this.redirectToAva({id: this.dataList[0].id}, true);
          } else {
            this.redirectToAva({id: res.data[0].current}, true);
          }
        }
      )
  }

  back(): void {
    window.history.back();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/listagem-etapas-cursos/listagem-etapas-cursos.component.ts